import * as React from "react";
import { useMemo, useState } from "react";

import { ChevronDown, ChevronUp } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, Icon } from "@livechat/design-system-react-components";

import { ITicket, TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";

interface IProps {
  ticket: ITicket;
  onStatusUpdate(status: TicketStatus): void;
  disabled: boolean;
}

const StatusSwitcher: React.FC<IProps> = ({ ticket, disabled, onStatusUpdate }) => {
  const [toggled, setToggled] = useState(false);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleStatusSelect = (status: TicketStatus) => {
    onStatusUpdate(status);
    setToggled(false);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpen = () => {
    setToggled(true);
  };

  const options = useMemo(
    () =>
      [TicketStatus.Open, TicketStatus.Pending, TicketStatus.OnHold, TicketStatus.Solved, TicketStatus.Closed].map(
        ticketStatus => ({
          key: ticketStatus,
          element: <ActionMenuItem>{TicketStatusFormattedValues[ticketStatus]}</ActionMenuItem>,
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          onClick: () => handleStatusSelect(ticketStatus),
        })
      ),
    [ticket.status, onStatusUpdate, disabled]
  );

  return (
    <div css={{ display: "inline-flex" }}>
      <ActionMenu
        visible={toggled}
        placement="bottom-start"
        selectedOptions={[ticket.status]}
        options={options}
        onClose={() => setToggled(false)}
        triggerRenderer={
          <Button
            data-testid="ticket-details-change-status-button"
            size="xcompact"
            disabled={disabled}
            kind="secondary"
            iconPosition="right"
            icon={<Icon source={toggled ? ChevronUp : ChevronDown} />}
            onClick={handleOpen}
            css={{ fontWeight: 400 }}
          >
            {TicketStatusFormattedValues[ticket.status]}
          </Button>
        }
      />
    </div>
  );
};

export default StatusSwitcher;
